import {
  FORCE_ERROR_FALLBACK,
  FORCE_SUCCESS_MESSAGE,
} from '../constants/forceGuarantee';

// Mappers from the raw GraphQL payloads to the shapes the reducer stores and
// the views render. Kept free of React and Redux so they can be unit tested.

export const toTransaction = order => ({ ...order, id: order.orderId });

export const toRuleOutcome = (outcome, index) => ({
  id: `${outcome.ruleName}-${index}`,
  ruleName: outcome.ruleName,
  outcome: outcome.passed ? 'pass' : 'fail',
  reason: outcome.reason,
});

// Transport/GraphQL failures: prefer the message the backend sent, because it
// tells the operator whether retrying makes any sense at all.
export const toErrorMessage = (error, fallback) => {
  if (!error) return null;
  const graphQLErrors = error.graphQLErrors || [];
  return (graphQLErrors[0] && graphQLErrors[0].message) || fallback;
};

// APMS failures come back as `success: false` with a generic message in
// `errors` — the real APMS status/body is never exposed to the frontend.
export const toForceResult = payload => {
  const result = payload || {};
  const errors = result.errors || [];
  return {
    success: !!result.success,
    status: result.forceGuaranteeResult
      ? result.forceGuaranteeResult.status
      : null,
    message: result.success
      ? FORCE_SUCCESS_MESSAGE
      : errors.join(' ') || FORCE_ERROR_FALLBACK,
  };
};
